import $rdf from '@zazuko/env/web.js';
import { toSparql } from 'clownface-shacl-path';
export function createVariableSequence(prefix) {
    let i = 1;
    const subjects = $rdf.termMap();
    const seq = () => {
        return $rdf.variable(`${prefix}${i++}`);
    };
    seq.for = (subject, path) => {
        const properties = subjects.get(subject) || new Map();
        subjects.set(subject, properties);
        const pathSparql = toSparql(path).toString({ prologue: false });
        const variable = properties.get(pathSparql) || seq();
        properties.set(pathSparql, variable);
        return variable;
    };
    return seq;
}
